export default "__VITE_ASSET__ZA5WhaYA__"